import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, IconButton, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { AppConfig } from 'AppConfig';
import axios from 'axios';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from 'common/BstAccordion';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { store } from 'store/store';
import { viewReport } from '../actions/actions';
import ManageReportDetail from './detail';

const GreenTypography = withStyles({
  root: {
    color: '#46C646'
  }
})(Typography);

const ManageReportAccordion = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { views, onSubmit } = props;

  const [expandBitmap, setExpandBitmap] = useState(
    new Array(views.length).fill(false)
  );

  const updateBitmap = (i) => {
    let newExpanded = [...expandBitmap];
    newExpanded[i] = !expandBitmap[i];
    setExpandBitmap(newExpanded);
  };

  const handleExpand = (i) => (_e, _isExtended) => {
    updateBitmap(i);
  };

  const handleCancel = (i) => {
    updateBitmap(i);
  };

  const handleSubmit = (data, i) => {
    axios
      .post(AppConfig.FO_INITIAL_URL + '/init/workbook-meta-save', [data])
      .then((_res) => {
        updateBitmap(i);
        onSubmit();
      });
  };

  const renderView = (view, i) => {
    return (
      <Accordion
        key={`view-${view.viewName}-${i}`}
        expanded={expandBitmap[i]}
        onChange={handleExpand(i)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box
            display="flex"
            flexDirection="row"
            flexWrap="none"
            flexGrow={1}
            alignItems="center"
            justifyContent="start">
            <IconButton
              className="p-1"
              onClick={(e) => {
                e.stopPropagation();
                store.dispatch(viewReport(view, navigate, location));
              }}>
              <VisibilityIcon />
            </IconButton>
            <Box className="pl-1">
              {view.inFo ? (
                <GreenTypography>{view.viewName}</GreenTypography>
              ) : (
                <Typography>{view.viewName}</Typography>
              )}
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <ManageReportDetail
            report={view}
            onCancel={() => handleCancel(i)}
            onSubmit={(data) => handleSubmit(data, i)}
          />
        </AccordionDetails>
      </Accordion>
    );
  };

  return <>{views.map((v, i) => renderView(v, i))}</>;
};

export default ManageReportAccordion;
